import { Component, OnInit } from '@angular/core';
import { CommonRequestResponseService } from 'app/services';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  dynamicHTML: HTMLElement;

  constructor(
    public _commonRequestResponseService: CommonRequestResponseService
  ) {}

  ngOnInit() {
    const partnerDetail = JSON.parse(localStorage.getItem('partnerDetail'));
    const inputId = partnerDetail ? partnerDetail.partnerId : 0;
    this.getFaqData(inputId);
  }

  getFaqData(id) {
    const jsonInput = {
      partnerId: id
    }
    this._commonRequestResponseService.postWithHeader('shared/GetFAQDetails', jsonInput)
    .subscribe(
      (response: any) => {
        if (response) {
          this.dynamicHTML = response.apiUrl
        }
      },
      (error: any) => {

      }
    )
  }

}
